// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"tips-double"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 6L22 19L16.5 19L13.5 22L10.5 19L5 19L5 6L22 6Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 6L22 19L16.5 19L13.5 22L10.5 19L5 19L5 6L22 6Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M18 2.5L1.5 2.5L1.5 14.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TipsDoubleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tips-double',
    ref,
    icon: element,
  },
));

TipsDoubleIcon.displayName = 'TipsDoubleIcon';

export default TipsDoubleIcon;
